import React, { useEffect, useRef, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import Status from "../ui/Status";
import { HelpIcon, InfoIcon, SettingsIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import CategorySelectorInput from "../ui/CategorySelectorInput";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import { arrayToObject, getEnumLabel, getSaved, kbdEvent, removeKey, requestPrompt, save, showHelp, splitClassString, ucfirst } from "../utils/Utils";
import { createScreen } from "../hooks/createScreen";
import AuthorPickerScreen from "../screens/AuthorPickerScreen";

import Bisacs from "../popovers/Bisacs";
import { VALIDATE } from "../utils/Validators";
import Spin from "../ui/Spin";
import { getSignal, setSignal } from "../App";
import Float from "../ui/Float";
import Button from "../ui/Button";
import Checkbox from "../ui/Checkbox";
import ToolTip from "../ui/ToolTip";
import { drawPicker } from "../popovers/Picker";
import { getValue } from "@testing-library/user-event/dist/utils";
import Segmented from "../ui/Segmented";
import { ENUMS } from "../utils/Enums";
import { useTabs } from "../hooks/useTabs";
import CustomersController from "./CustomersController";
export default function OrdersSearch(props) {

    const { controller = "", route = "", signal = {}, setSelected = () => { }, selected = false, setStock = () => { }, callback = () => { }, onSearch = () => { } } = props;
    const [loading, setLoading] = useState(false);



    const [defaults, setDefaults] = useState({
        limit: 100,
        sort: "I",
        scope: "A",
        default_search: "titlelink"
    })




    const defaultTabs = [
        // Main

        { key: "isbn", value: "", skip: false },
        { key: "title", value: "", skip: false },
        { key: "customer", value: "", skip: false },
        { key: "customer_id", value: "", skip: true },
        { key: "order", value: "", skip: false },
        { key: "order_supplier", value: "", skip: false },
        { key: "order_title", value: "", skip: false },
        { key: "supplier", value: "", skip: false },
        { key: "supplier_title", value: "", skip: false },
        { key: "invoice", value: "", skip: false },
        { key: "invoice_title", value: "", skip: false },
        { key: "specials", value: "", skip: false },

    ];



    const { tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs } = useTabs(defaultTabs, "isbn");


    const tabsRef = useRef(tabs);

    useEffect(() => {
        tabsRef.current = tabs;
    }, [tabs]);


    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }





    // Auto focus the field
    useEffect(() => {
        // refs.current[index].focus();
    }, [index])




    const normalizeSearchType = (_index) => {
        if (["order_supplier", "order_title"].includes(_index)) return "order";
        if (["supplier_title"].includes(_index)) return "supplier";
        if (["invoice_title"].includes(_index)) return "invoice";

        return _index;
    };

    // Pubsub calls + send results to callback
    const callSearch = (_search = null, _index = index) => {


        const search = {
            ...arrayToObject(tabsRef.current),
            [_index]: refs.current?.[_index]?.value ?? getVal(_index),
        };

        setLoading(true);
        onSearch({
            type: normalizeSearchType(_index),
            values: search,
        }, (_s, _r) => {

            if (_s) {
                // worked, close
                callback(false)
            }
            setLoading(false);


        });
    };





    // Keyboard Events
    useEffect(() => {

        if (refs?.current?.[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ARROW_DOWN, action: (e) => { next() } },
            { key: KBD.ARROW_UP, action: (e) => { prev() } },
            { key: KBD.PAGE_UP, action: (e) => { callSearch(); } },
            { key: KBD.PAGE_DOWN, action: (e) => { callSearch(); } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ESCAPE, KBD.ALT_S, KBD.ALT_H, KBD.ALT_L]);
        return cleanup;
    }, [index, loading, defaults]);



    const statuses = {
        recent: "Enter a record # to jump to, or leave blank and <enter> for most recent entries",
        isbn: "",
        title: "Text after comma (,) will be used as a title filter",
        customer: "",
        order: "",
        order_supplier: "",
        order_title: "Text after comma (,) will be used as a title filter",
        supplier: "",
        supplier_title: "Use title only if searching active orders",
        invoice: "",
        invoice_title: "",
        specials: "",
    }


    const selectCustomer = (_search = "") => {
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        blurField();
        createScreen({
            signal: signal,
            component: <CustomersController controller={controller} is_modal search={_search} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = route;
                if (_obj) {
                    update({
                        customer_id: _obj.person_id,
                        customer: _obj.name
                    })
                }
                focusField();
            }
        });
    }


    // Draw
    return (
        <Spin style={{ "margin": "0px -10px" }} loading={loading}>


            <div style={{ "width": "600px", "padding": "0px 10px" }}>


                <div className="shim" /><div className="shim" /><div className="shim" />

                <Space height={25} size={10}>
                    <Label className={(index === "isbn") ? "selected" : ""} width={80}>ISBN</Label>
                    <Input className={(index !== "isbn") ? "dim" : ""} {...editProps("isbn")} onEnter={() =>callSearch()} />
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === "title") ? "selected" : ""} width={80}>Title</Label>
                    <Input className={(index !== "title") ? "dim" : ""} {...editProps("title")} />
                    {(index === "title" && <Label>(active titles only)</Label>)}
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === "customer") ? "selected" : ""} width={80}>Customer</Label>
                    <Input className={(index !== "customer") ? "dim" : ""} {...editProps("customer")}
                        onEnter={(_search) => selectCustomer(_search)}

                    />



                    {/* <Input feedback={(index === "customer.name" && customerValid) ? customerValid : ""} className={hasSplit(getVal("ms_split")) ? "dim" : ""} grow {...editProps("customer.name")}
                            onEnter={(e) => {
                                let _c = getVal("customer");
                                if ((e && _c?.name === e) || !e) {
                                    // didn't change anything.. just skip
                                    next();
                                } else {
                                    validateCustomer(e)
                                }
                            }}
                            onBlur={(e) => {
                                let _c = getVal("customer");
                                if (e && _c?.name && _c?.name !== e) {
                                    // changed it but didn't set...
                                    update("customer.name", _c.name)
                                }
                            }}
                            onClear={() => {
                                update("customer", null);
                            }}
                            onSearch={(e) => validateCustomer(e)}
                            onPageUp={(e) => validateCustomer(e)}
                            doubleclick={(e) => { validateCustomer(e.target.value) }}

                        />

                         */}
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label className={(index === "order") ? "selected" : ""} width={80}>Order#</Label>
                    <Input className={(index !== "order") ? "dim" : ""} width={80} {...editProps("order")} />
                    <Label>Supl</Label>
                    <Input className={(index !== "order") ? "dim" : ""} width={65} {...editProps("order_supplier")} />
                    <Label>Title</Label>
                    <Input className={(index !== "order") ? "dim" : ""} {...editProps("order_title")} />
                </Space>
                <div className="shim" />

                <Space height={25} size={10}>
                    <Label className={(index === "supplier") ? "selected" : ""} width={80}>Supplier</Label>
                    <Input className={(index !== "supplier") ? "dim" : ""} width={80} {...editProps("supplier")} />
                    <Label>Title</Label>
                    <Input className={(index !== "supplier") ? "dim" : ""} {...editProps("supplier_title")} />
                </Space>
                <div className="shim" />

                <Space height={25} size={10}>
                    <Label className={(index === "invoice") ? "selected" : ""} width={80}>Invoice#</Label>
                    <Label>Supl</Label>
                    <Input className={(index !== "invoice") ? "dim" : ""} width={60} {...editProps("invoice")} />
                    <Label style={{ "textAlign": "left" }} width={95}>Inv#</Label>
                    <Label>Title</Label>
                    <Input className={(index !== "invoice") ? "dim" : ""} {...editProps("invoice_title")} />
                </Space>
                <div className="shim" />

                <Space height={25} size={10}>
                    <Label className={(index === "specials") ? "selected" : ""} width={80}>Specials</Label>
                    <Input className={(index !== "specials") ? "dim" : ""} width={20} {...editProps("specials")} />
                    {(index === "specials" && <Label>start from [N]ewest [O]ldest [F]iltered</Label>)}
                </Space>
                <div className="shim" />





                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />

                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px", "borderBottomLeftRadius": "5px", "borderBottomRightRadius": "5px" }}>
                    <Status><InfoIcon /> {statuses[index]}</Status>
                </div>

            </div>
        </Spin>
    )
}